import React from 'react';

const AudioPlayer = (props) => {
  const audioUrl = props.audioUrl;

  return (
    <div>
      <audio controls>
        <source src={audioUrl} type="audio/mpeg" />
      </audio>
    </div>
  );
}

export default AudioPlayer;
